











import Vue from "vue";
import CustomTable from "@/components/Table/table.vue";
import { DataTableHeader } from "vuetify/types";
import { MainStateEnum } from "@/types/types";
import { store } from "@/store/store";

interface DeviceTableData {
  headers: Array<DataTableHeader>;
  items_displayed: Array<string>;
}

export interface CategoryData {
  _id: string;
  category: string;
  onfield: number;
  total: number;
}

export default Vue.extend({
  name: "StatusTable",
  components: { CustomTable },
  props: {
    hideDefaultFooter: {
      type: Boolean,
      default: false
    },
    onRowClick: {
      type: Function,
      default: () => undefined
    }
  },
  data: (): DeviceTableData => {
    return {
      headers: [
        { text: "Catégorie", value: "category", align: "start", sortable: true },
        { text: "Posés", align: "start", value: "onfield", sortable: false },
        { text: "Total", align: "start", value: "total", sortable: false }
      ],
      items_displayed: []
    };
  },
  methods: {
    format_data(): Array<CategoryData> {
      let array_data: Array<CategoryData> = [];
      const devices = store.getters.DEVICE_ALL_ID;
      devices.forEach((device_id) => {
        const device = { ...store.getters.DEVICE_BY_ID[device_id] };
        const category_name = store.getters.CATEGORY_BY_ID[device.category].name;
        const category_data = array_data.find((category) => category.category === category_name);
        const main_state_name = store.getters.MAIN_STATE_BY_ID[store.getters.STATE_BY_ID[device.state].main_state].name;
        if (category_data) {
          category_data.onfield += main_state_name === MainStateEnum.TERRAIN ? 1 : 0;
          category_data.total += 1;
        } else {
          array_data.push({
            _id: device.category,
            category: category_name,
            onfield: main_state_name === MainStateEnum.TERRAIN ? 1 : 0,
            total: 1
          });
        }
      });
      return array_data;
    }
  }
});
